import { useFlags } from "launchdarkly-react-client-sdk";
import { PageSpinner } from "src/components/loading";
import { useResourcePermission } from "src/components/permission/use-resource-permission";
import { useUser } from "src/contexts/user-context";
import { isPermissionsTabAccessible } from "src/events/permissions-tab-access";
import { Navigate, useLocation } from "src/router";
import { lazyNamed } from "src/utils/lazy-named";

import { useEventSourceOutletContext } from "./source/outlet";

const EventSourcePermissions = lazyNamed(
  () => import("./source/grants"),
  "EventSourcePermissions",
);

export const EventSourcePermissionsRoute = () => {
  const location = useLocation();
  const { user } = useUser();
  const { eventsRbacEnabled } = useFlags();
  const { source } = useEventSourceOutletContext();
  const permissions = useResourcePermission({
    v2: {
      resource: "event_source",
      grant: "can_update",
      id: source.id,
    },
  });
  const showPermissions = isPermissionsTabAccessible({
    eventsRbacEnabled,
    resource: source,
    user,
    permissions,
  });

  if (!eventsRbacEnabled) {
    return (
      <Navigate
        to={{ pathname: "../overview", search: location.search }}
        relative="path"
        replace
      />
    );
  }

  if (permissions.isLoading) {
    return <PageSpinner />;
  }

  if (!showPermissions) {
    return (
      <Navigate
        to={{ pathname: "../overview", search: location.search }}
        relative="path"
        replace
      />
    );
  }

  return <EventSourcePermissions />;
};
